// extracted by mini-css-extract-plugin
export var flexbox = "contentgrid-module--flexbox--c7fa4";
export var grid = "contentgrid-module--grid--d38a7";